<template>
  <MainLayout :title="$t('pages.dashboard')">
    <div slot="content">
      <SearchBar v-model.trim="searchTerm" />
      <DefinitionsTable
        class="definitionsTable"
        :searchTerm="searchTerm"
        :definitions="highlightedText"
        :showDefinitionsList="showDefinitionsList"
      />
    </div>
  </MainLayout>
</template>

<script>
import _ from "lodash";
import MainLayout from "@/layouts/Main";
import SearchBar from "@/components/definitions/SearchBar";
import DefinitionsTable from "@/components/definitions/DefinitionsTable";

export default {
  name: "Definitions",
  components: {
    MainLayout,
    SearchBar,
    DefinitionsTable,
  },
  data() {
    return {
      searchTerm: "",
      showDefinitionsList: true,
    };
  },
  computed: {
    i18nDefinitions() {
      return _.values(this.$t("analyticsDefinitions"));
    },
    searchTermRegex() {
      const searchTerm = this.searchTerm || "";
      const escapedSearchQuery = searchTerm.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
      return new RegExp(escapedSearchQuery, "gi");
    },
    searchResults() {
      return this.i18nDefinitions.filter((definition) => {
        return definition.term.match(this.searchTermRegex) || definition.definition.match(this.searchTermRegex);
      });
    },
    highlightedText() {
      if (this.searchTerm === "") {
        return this.i18nDefinitions;
      }
      const highlightedResults = this.searchResults.map((result) => {
        const term = result.term.replace(this.searchTermRegex, '<span class="highlight">$&</span>');
        const definition = result.definition.replace(this.searchTermRegex, '<span class="highlight">$&</span>');

        return {
          term,
          definition,
        };
      });

      return this.changeResultsOrder(highlightedResults);
    },
  },
  watch: {
    searchResults() {
      this.showDefinitionsList = this.searchResults.length > 0;
    },
  },
  mounted() {
    this.searchTerm = this.$route.query.q;
  },
  methods: {
    changeResultsOrder(array) {
      return array.sort((a, b) => {
        if (a.term.includes("highlight") && b.term.includes("highlight")) {
          return 0;
        } else if (a.term.includes("highlight")) {
          return -1;
        }
        return 0;
      });
    },
  },
};
</script>

<style lang="scss">
.definitionsTable {
  .highlight {
    background: #ffdb3a;
  }
}
</style>
